import React from "react";

const Definition = () => {
  return (
    <p className="text-center mt-4 px-2">
      Стойността <span className="text-danger">"Позитивност"</span> в следната
      диаграма изразява колко положителна е дадена песен чрез число между 0 и 1.
      Колкото тя е по-близо до 1, толкова по-позитивно е чувството на песента.
    </p>
  );
};

export default Definition;
